import React from 'react'
import styles from './UIGameBarbarianInvasionTracker.module.scss'
/* eslint-disable no-restricted-imports */
import clsx from 'clsx'
import {UIGameBarbarianInvasionTrackerHex} from './UIGameBarbarianInvasionTrackerHex'
import {UIGameBarbarianInvasionTrackerShip} from './UIGameBarbarianInvasionTrackerShip'
import {UIGameBarbarianInvasionTrackerKnight} from './UIGameBarbarianInvasionTrackerKnight'

const getHexType = (idx: number, barbarianProgress: number, progressWhenBarbariansAttack: number) => {
    if(idx === progressWhenBarbariansAttack) return 'attack'
    if(idx === barbarianProgress) return 'active'
    return 'inactive'
}
export interface UIGameBarbarianInvasionTrackerProps {
    knightStrength: number
    barbarianStrength: number
    barbarianProgress: number
    progressWhenBarbariansAttack: number
    className?: string
}

export const UIGameBarbarianInvasionTracker = ({
    knightStrength,
    barbarianStrength,
    className,
    barbarianProgress,
    progressWhenBarbariansAttack,
}: UIGameBarbarianInvasionTrackerProps) => {
    const arePlayersWinning = knightStrength >= barbarianStrength
    const trackerPositionX = barbarianProgress % 2 === 0 ? 0 : 23
    const trackerPositionY = barbarianProgress * 80
    return <div className={clsx(styles.container, className)}>
        {Array.from({length: progressWhenBarbariansAttack + 1}).map((_, idx) => (
            <UIGameBarbarianInvasionTrackerHex
                className={styles.hexIcon} key={idx}
                type={getHexType(idx, barbarianProgress, progressWhenBarbariansAttack)} />
        ))}
        <div
            className={styles.barbarianIcons}
            style={
                {transform: `translate(${trackerPositionX}%,${trackerPositionY}%)`}
            }>
            <UIGameBarbarianInvasionTrackerShip barbarianStrength={barbarianStrength} />
            <UIGameBarbarianInvasionTrackerKnight arePlayersWinning={arePlayersWinning} knightStrength={knightStrength}/>
        </div>
    </div>
}
